import { ref, watch } from 'vue'

// A true/false setting kept in this browser's localStorage, so it is still what the user chose after a refresh or a later visit. It is read
// straight away (no flash of the default on load) and written whenever it changes. Where storage is blocked (private windows, site data off)
// it still works for the page, it just is not remembered.
export function useStoredFlag(key, fallback = false) {
  const read = () => {
    try {
      const stored = localStorage.getItem(key)
      return stored === null ? fallback : stored === 'true'
    } catch {
      return fallback
    }
  }

  const flag = ref(read())
  watch(flag, (value) => {
    try {
      localStorage.setItem(key, String(value))
    } catch {
      // not remembered, fine
    }
  })
  return flag
}
